(ns livefeed.quote
  (:require
   [livefeed.i18n :refer [translate]]
   [reagent.core :as reagent :refer [atom]]))

(defn message-quote [quote]
  (let [quote-status (atom :contracted)
        toggle-quote (fn []
                       (let [next-state  {:contracted  :expanded
                                          :expanded    :contracted}]
                         (swap! quote-status next-state)))]
    (reagent/create-class
     {:reagent-render
      (fn [quote]
        (let [content (or (:content quote) "")
              short-content (-> content (subs 0 70))]
          [:div.yle-livefeed__messages__message__quote {:on-click toggle-quote}
           [:div.yle-livefeed__messages__message__quote__user
            (get-in quote [:chat-user :nick])]
           [:div.yle-livefeed__messages__message__quote__content
            (when-not (= short-content content)
              {:class (str "yle-livefeed__messages__message__quote__content--" (name @quote-status))})
            (if (= @quote-status :contracted) short-content content)
            (when-not (= short-content content)
              [:<>
               (when (= @quote-status :contracted) "...")
               [:span.yle-livefeed__messages__message__quote__content__show-more
                (if (= @quote-status :contracted) (translate :quote-show-more) (translate :quote-show-less))]])]]))})))
